import isUndefined from "lodash.isundefined";
import formatInterval from "../../../util/format-interval";
import { getReadingFrequency } from "../../../util/reading-frequency";

/**
 * Reading schedule + interval settings for the slide-out.
 * Read-only here; the settings themselves live in the sub account.
 */
const sensorSchedule = sensor => {

  const rows = [];

  if(sensor.next_checkin) {

    const next = window.getUserTimezoneDate(sensor.next_checkin);
    const isOverdue = next.valueOf() < Date.now();

    const relative = isOverdue
      ? "overdue"
      : `in ${window.getPrettyNextCheckin(sensor.next_checkin)}`;

    rows.push({
      label: "Next Reading",
      value: `${next.format("MMM D, Y h:mm a")} <span class="dashboard-active-sensor__schedule__note">(${relative})</span>`,
    });

  } else {
    rows.push({ label: "Next Reading", value: "Unknown" });
  }

  // how often a reading is taken vs. how often readings are uploaded; the two
  // only differ when battery saver (log) mode batches the uploads
  const { readingSecs, uploadSecs } = getReadingFrequency(sensor);

  rows.push({
    label: "Reads Every",
    value: readingSecs === null ? "&mdash;" : formatInterval(readingSecs),
  });

  let uploadNote = "";

  // log mode is only available from firmware 2013 up
  if(!isUndefined(sensor.log_secs)) {
    const batterySaverOn = String(sensor.use_log_mode) === "1";
    uploadNote = ` <span class="dashboard-active-sensor__schedule__note">(battery saver ${batterySaverOn ? "on" : "off"})</span>`;
  }

  rows.push({
    label: "Uploads Every",
    value: uploadSecs === null ? "&mdash;" : `${formatInterval(uploadSecs)}${uploadNote}`,
  });

  return `
    <div class="dashboard-active-sensor__schedule">
      <h3>Reading Schedule</h3>
      ${rows.map(row => `
        <div class="dashboard-active-sensor__schedule__row">
          <div class="dashboard-active-sensor__schedule__label">${row.label}</div>
          <div class="dashboard-active-sensor__schedule__value">${row.value}</div>
        </div>
      `).join("")}
    </div>
  `;

};

export default sensorSchedule;
